import arenaLogo from "../../assets/logo.svg";
import { usePortalBranding } from "@/contexts/portalBranding";

interface ArenaLogoProps {
  className?: string;
}

/**
 * The auth-surface logo mark. On a white-label portal it wears the brand's
 * logo (or holds its space when the brand has name-only branding); while
 * branding is still resolving it also holds the space rather than flashing
 * the Reveshare mark inside a brand's portal.
 */
export const ArenaLogo = ({ className = "" }: ArenaLogoProps) => {
  const { isWhiteLabel, portalLogo, portalName, isReady } = usePortalBranding();

  if (isWhiteLabel && portalLogo) {
    return (
      <img
        src={portalLogo}
        alt={portalName}
        className={`${className} object-contain`}
      />
    );
  }

  if (isWhiteLabel || !isReady) {
    return <div className={`${className} aspect-square`} aria-hidden="true" />;
  }

  return <img src={arenaLogo} alt="Arena Logo" className={className} />;
};
